import React, { createContext, useContext, useState } from "react";

const DateRangeContext = createContext(null);

function iso(d) {
  return d.toISOString().slice(0, 10);
}

export function DateRangeProvider({ children }) {
  const today = new Date();
  const start = new Date();
  start.setDate(today.getDate() - 29);
  const [range, setRange] = useState({ from: iso(start), to: iso(today) });
  const [search, setSearch] = useState("");

  const setPreset = (days) => {
    const to = new Date();
    const from = new Date();
    from.setDate(to.getDate() - (days - 1));
    setRange({ from: iso(from), to: iso(to) });
  };

  return (
    <DateRangeContext.Provider value={{ range, setRange, setPreset, search, setSearch }}>
      {children}
    </DateRangeContext.Provider>
  );
}

export function useDateRange() {
  return useContext(DateRangeContext);
}
